import { render } from "./ScrollThumbBlock.vue?vue&type=template&id=71dedf2e&scoped=true"
import script from "./ScrollThumbBlock.vue?vue&type=script&lang=js"
export * from "./ScrollThumbBlock.vue?vue&type=script&lang=js"

import "./ScrollThumbBlock.vue?vue&type=style&index=0&id=71dedf2e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71dedf2e"]])

export default __exports__